$(document).ready(function() {
 
    $('.logos-slider').owlCarousel({
   
        // stagePadding:10,
        // autoWidth:false, 	
         autoplay: true,
         slideTransition: 'linear',
        // autoplayTimeout: 5000,
        smartSpeed: 5000,
        slideSpeed: 5000,
        // center: true,
        // dots: false,
        // nav: false,
        // // loop: true,
        // ltr: true,
        loop:false,
        margin:10,
        nav:false,
        dots:false,
          
      
        responsive:{
            0:{
                items:1,
              
    
            },
            768:{
                items:4,
               
             }
        }
    })

    $('.hero-slider').owlCarousel({
   
        loop:true,
        margin:10,
        nav:false,
        autoplay:false,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        responsive:{
            0:{
                items:1,
              
    
            },
            768:{
                items:1,
               
             }
        }
    })  




    // $(".accordion").click(function(){
    //     $(this).siblings().slideToggle("slow");
    //   });
    
    
  });


   // show Momentum Points next to price
   var paywithpoints_el = $('#ProductPrice.money[itemprop=price]');
   if (paywithpoints_el.length) {
       // This function is used in the callback for when a product variant is changed (product.liquid)
       window.setPayWithPointsPrice = function() {
           var paywithpoints_text = paywithpoints_el.text()
               , paywithpoints_price_num = Number(paywithpoints_text.replace(/[^\d.]/g,''))
               , paywithpoints_price_points = (Math.round(paywithpoints_price_num * 100)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
           ;
           $('#priceInMomentumPoints').text(paywithpoints_price_points);
       }
       function addingPayWithMomentumPointsGraphic () {
           if (!$('#priceInMomentumPoints').length) {
               paywithpoints_el.after(' <sup class="money color_black" style="font-size:12px;margin-left:10px;margin-right:10px;">OR</sup> <i id="priceInMomentumPoints" class="money color_orange" style="font-style:normal;"></i><span style="height:24px;display: inline-grid;margin-left:10px;margin-top:-24px;cursor:pointer; font-family:Axiforma-bold; font-size:16px;" class="verticalAlignMiddle momentum-text-in-points" onclick="showMomentumPriceModal();" >Momentum&reg;<span class="break-points">Points</span></span>');
               setPayWithPointsPrice();
           }
           setTimeout(addingPayWithMomentumPointsGraphic, 100);
       }
       addingPayWithMomentumPointsGraphic();
       if (!$('#icon_momentum_price_info').length) {
           var icon_momentum = "https://s3.amazonaws.com/onecondoms/myone/images/icon_momentum_price_info.png";
           $('body').append('<a id="icon_momentum_price_info" href="'+icon_momentum+'" data-featherlight="'+icon_momentum+'" class="displayNone"></a>');
           showMomentumPriceModal = function () {
               $('#icon_momentum_price_info').trigger('click');
               setTimeout(function() {
                   $('img[src="'+icon_momentum+'"]').css({cursor: 'pointer'}).on('click', function(event) {
                       window.location.href = '<%= site_url %>pages/momentum';
                   });
               }, 500);
           };
       }
   }//paywithpoints price


   $(".custom-accordian").click(function(){
    $(this).siblings().slideToggle("slow");
  });


  // stay in touch form js
  var submitBtn = document.getElementById("submit-btn");

  submitBtn.addEventListener("click", function (evt) {
    evt.preventDefault();
    window.location.replace("https://www.onecondoms.com/pages/thank-you");
    return false; 
   });


